// GlobalContext.tsx
import React, { createContext, useReducer, useContext, ReactNode } from 'react';
import { GlobalState, GlobalAction } from '../data/GlobalState';
import { newConferenceInfo } from '../data/conferenceInfo';
import { newEventInfo } from '../data/eventInfo';
import { newAuthUser } from '../data/auth/authUser';


const initialState: GlobalState = {
    UserProfile: newAuthUser(),
    theme: 'light',
    SelectedEventId: '',
    Conference: newConferenceInfo(),
    Profiles: [],
    SelectedEvent: newEventInfo()
};

export const GlobalContext = createContext<{
    state: GlobalState;
    dispatch: React.Dispatch<GlobalAction>;
  }>({
    state: initialState,
    dispatch: () => null, // noop default dispatch
  });

const globalReducer = (state: GlobalState, action: GlobalAction): GlobalState => {
  
  switch (action.type) {
    // case 'SET_USER':
    //   //alert(action.authuser?.FirstName);
    //   return { ...state, UserProfile: action.UserProfile };
    case 'SET_CONFERENCE':
        return { ...state, Conference: action.Conference };
    case 'SET_PROFILES':
        return { ...state, Profiles: action.Profiles };
    case 'SET_SELECTEDEVENTID':
        return { ...state, SelectedEventId: action.SelectedEventId };
    case 'SET_SELECTEDEVENT':
        return { ...state, SelectedEvent: action.SelectedEvent };
    case 'SET_USERPROFILE':
      return { ...state, UserProfile: action.UserProfile };
    case 'TOGGLE_THEME':
      return { ...state, theme: state.theme === 'light' ? 'dark' : 'light' };
    default:
      return state;
  }
};

export const GlobalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, initialState);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);
